import { ContainerPadding, Text, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import React, { useEffect, useState } from 'react';
import { ConsentimientosEnvioSection } from '../../components/inputs-group/consentimientos-envio-section';
import { CodigoPostalInput } from '../../components/inputs-group/inputs/codigo-postal-input';
import { ComentarioInput } from '../../components/inputs-group/inputs/comentario-input';
import { CtasRadio } from '../../components/inputs-group/inputs/core/ctas-radio';
import { SelectExtended } from '../../components/inputs-group/inputs/core/select-extended';
import { DealersRadio } from '../../components/inputs-group/inputs/dealers-radio';
import { DniInput } from '../../components/inputs-group/inputs/dni-input';
import { EmailInput } from '../../components/inputs-group/inputs/email-input';
import { FechaInput } from '../../components/inputs-group/inputs/fecha-input';
import { LettersInput } from '../../components/inputs-group/inputs/letters-input';
import { PaisMatriculaInput } from '../../components/inputs-group/inputs/pais-matricula-input';
import { TelefonoInput } from '../../components/inputs-group/inputs/telefono-input';
import { TratoNombreInput } from '../../components/inputs-group/inputs/trato-nombre-input';
import { VehicleSection } from '../../components/inputs-group/inputs/vehicle-section/vehicle-section';
import { LegalesSection } from '../../components/inputs-group/legales-section';
import { InputsGroup } from '../../components/screen/inputs-group';
import { Section } from '../../components/screen/section';
import { FIELD_NAME } from '../../constants/form-constants';
import { formService } from '../../form-service';
import { isComerciales } from '../../helpers/carline-helpers';
import { getCountries } from '../adhoc/theoriginals-2026/helper';

export const TestForm = () => {
	const getFormData = () => {
		const data = {
			'headers[FK_SYSTEM]': isComerciales() ? 'LCV_DDB_FRM_LEM_REC_LEM' : 'VW_DDB_FRM_LEM_REC_LEM',
			'headers[DPS_TOKEN]': isComerciales() ? 'LCV_DDB_FRM_LEM_REC_LEM' : 'VW_DDB_FRM_LEM_REC_LEM',

			'flags[PERSON_RGPD_ADAPTED]': true,
			'flags[FLAG_IS_MYSTERY_LEAD]': false,
			'flags[FLAG_RELACION_MARCA_SIN_IC]': false,
			'flags[FLAG_SF_INTEGRATION]': true,
			'flags[FLAG_IS_COMPANY]': isComerciales() ? false : undefined,
			'flags[FLAG_ALLOWS_DATA_ENRICHMENT]': isComerciales() ? undefined : false,

			'fields[PERSON_NAME]': formService.getFieldValue(FIELD_NAME.NAME),
			'fields[PERSON_SURNAME_1]': formService.getFieldValue(FIELD_NAME.SURNAME_1),
			'fields[PERSON_SURNAME_2]': formService.getFieldValue(FIELD_NAME.SURNAME_2),
			'fields[PERSON_EMAIL]': formService.getFieldValue(FIELD_NAME.EMAIL),
			'fields[PERSON_PHONE_MOBILE]':
				formService.getFieldValue(FIELD_NAME.PHONE_PREFIX) + formService.getFieldValue(FIELD_NAME.PHONE),
		};

		return data;
	};

	const Form = () => {
		const [quieroDealer, setQuieroDealer] = useState(formService.getFieldValue('quieroDealer'));

		useEffect(() => {
			return formService.subscribeToField('quieroDealer', {
				onChange: setQuieroDealer,
			});
		}, []);

		useEffect(() => {
			if (quieroDealer !== 'si') {
				formService.clearField(FIELD_NAME.DEALER);
				formService.clearField(FIELD_NAME.SEARCHED_DEALER);
			}
		}, [quieroDealer]);

		return (
			<>
				<Section paddingBottom={ContainerPadding.static515}>
					<Text bold appearance={TokenTextAppearance.headline400}>
						TEST FORM
					</Text>
				</Section>
				<VehicleSection paddingBottom={ContainerPadding.static515} />
				<Section paddingBottom={ContainerPadding.static515}>
					<Text bold appearance={TokenTextAppearance.headline200}>
						Datos Personales
					</Text>
					<InputsGroup>
						<TratoNombreInput />
						<LettersInput name={FIELD_NAME.SURNAME_1} label="Primer apellido" required />
						<DniInput types={['DNI', 'NIE', 'PASAPORTE', 'OTRO']} required />
						<EmailInput required />
						<TelefonoInput required />
						<FechaInput
							name={FIELD_NAME.BIRTHDAY}
							label="Fecha nacimiento"
							required
							onlyAdults
							infoMessage="Recuerda: es solo para adultos"
						/>
						<PaisMatriculaInput />
						<CodigoPostalInput required />
						<LettersInput name={FIELD_NAME.CITY} label="Ciudad" required />
						<LettersInput name={FIELD_NAME.PROVINCE} label="Provincia" required />
						<SelectExtended name={FIELD_NAME.COUNTRY} label="País" options={getCountries()} value="ES" required />
					</InputsGroup>
				</Section>

				<Section paddingBottom={ContainerPadding.static400}>
					<ComentarioInput label="Por qué motivo te gusta Oneform" maxLength={100} required />
					<ComentarioInput name="motivo2" label="Si no te gustó..." maxLength={5} />
				</Section>

				<Section paddingBottom={ContainerPadding.static400}>
					<Text bold appearance={TokenTextAppearance.headline200}>
						¿Quieres seleccionar un dealer?
					</Text>
					<CtasRadio
						name="quieroDealer"
						options={[
							{ text: 'Sí', value: 'si' },
							{ text: 'No', value: 'no' },
						]}
						required
					/>
				</Section>

				{quieroDealer === 'si' && (
					<Section paddingBottom={ContainerPadding.static400}>
						<Text bold appearance={TokenTextAppearance.headline200}>
							Dealers Radio
						</Text>
						<DealersRadio />
					</Section>
				)}

				<ConsentimientosEnvioSection formData={getFormData} paddingBottom={ContainerPadding.static400} />
				<LegalesSection paddingBottom={ContainerPadding.static400} />
			</>
		);
	};

	return <Form />;
};
